import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=4e4a96f6&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4a96f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e4a96f6')) {
      api.createRecord('4e4a96f6', component.options)
    } else {
      api.reload('4e4a96f6', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=4e4a96f6&scoped=true&", function () {
      api.rerender('4e4a96f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N2sebWrya0Xw/JS/comp/Voucher-Unit.vue"
export default component.exports